module.exports = __webpack_public_path__ + "static/media/jp.16a568ca.svg";